export const GET_SETTINGS_LIST = 'GET_SETTINGS_LIST'
export const GET_SETTINGS_LIST_SUCCESS = 'GET_SETTINGS_LIST_SUCCESS'
export const GET_SETTINGS_LIST_FAILED = 'GET_SETTINGS_LIST_FAILED'

export const SET_SETTINGS_LIST = 'SET_SETTINGS_LIST'
export const SET_SETTINGS_LIST_SUCCESS = 'SET_SETTINGS_LIST_SUCCESS'
export const SET_SETTINGS_LIST_FAILED = 'SET_SETTINGS_LIST_FAILED'

export const REMOVE_SETTINGS_LIST = 'SET_SETTINGS_LIST'
export const REMOVE_SETTINGS_LIST_SUCCESS = 'SET_SETTINGS_LIST_SUCCESS'
export const REMOVE_SETTINGS_LIST_FAILED = 'SET_SETTINGS_LIST_FAILED'

export const SUPPORT_GET_SETTINGS_LIST = 'SUPPORT_GET_SETTINGS_LIST'
export const SUPPORT_GET_SETTINGS_LIST_SUCCESS = 'SUPPORT_GET_SETTINGS_LIST_SUCCESS'
export const SUPPORT_GET_SETTINGS_LIST_FAILED = 'SUPPORT_GET_SETTINGS_LIST_FAILED'

export const SUPPORT_SET_SETTINGS_LIST = 'SUPPORT_SET_SETTINGS_LIST'
export const SUPPORT_SET_SETTINGS_LIST_SUCCESS = 'SUPPORT_SET_SETTINGS_LIST_SUCCESS'
export const SUPPORT_SET_SETTINGS_LIST_FAILED = 'SUPPORT_SET_SETTINGS_LIST_FAILED'

export const SUPPORT_REMOVE_SETTINGS_LIST = 'SUPPORT_SET_SETTINGS_LIST'
export const SUPPORT_REMOVE_SETTINGS_LIST_SUCCESS = 'SUPPORT_SET_SETTINGS_LIST_SUCCESS'
export const SUPPORT_REMOVE_SETTINGS_LIST_FAILED = 'SUPPORT_SET_SETTINGS_LIST_FAILED'

export const GET_ENUM = 'GET_ENUM'
export const GET_ENUM_SUCCESS = 'GET_ENUM_SUCCESS'
export const GET_ENUM_FAILED = 'GET_ENUM_FAILED'
